<template>
    <div :data-toggle="minimal ? 'tooltip' : ''" data-placement="bottom" :title="$t('certificate.description')">
        <a :href="`/app/certificate/show/${relation.type}/${relation.id}`">
            <i class="mdi mdi-36px mdi-trophy certificate__trophy" :style="{color: '#2b2b29'}"></i> 
            <p v-if="!minimal" :style="{color: '#2b2b29'}">{{$t('certificate.description')}}</p>
        </a>
    </div>
</template>

<script>

    export default {
        name: "CertificateLink",

        props: {
            relation: {
                type: Object
            },
            certificate: {
                type: Object,
            },
            dark: Boolean,
            minimal: Boolean,
        },

        computed: {
            color() {
                return this.$store.getters.COLOR;
            },
        }
    }
</script>

<style scoped>
    .certificate__trophy {
        position: relative;
    }
</style>

<style>
    .certificate__bg ,
    .certificate__text{
        color: "#5E72E4";
    }
</style>
